var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#434345;opacity:0.01;isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-external") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76,56.5a4,4,0,0,0-4,4V80H16V24H35.5a4,4,0,0,0,0-8H12.8C10.15,16,8,17.7,8,19.79V84.21C8,86.3,10.15,88,12.8,88H75.2c2.65,0,4.8-1.7,4.8-3.79V60.5A4,4,0,0,0,76,56.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8,11.94a6.84,6.84,0,0,0-4.58-2h-.51L57,12a4,4,0,1,0,.32,8l14.43-1.64L49.86,40.2a4,4,0,0,0,5.65,5.66L77.41,24l-1.6,14.52a4,4,0,0,0,8,.32l2-21.78c0-.16,0-.33,0-.49A6.84,6.84,0,0,0,83.8,11.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.9f4363d007b4c1fc856ff74cbfb3392d.svg";
export { ForwardRef as ReactComponent };